export function generateAppLink(appId, brmId) {
    let baseUrl = "https://kuantumplus.rut.com.tr/";
    
    let returnUrl;
      returnUrl = `${baseUrl}d7aprun/Index?APP_ID=${appId}&BRM_ID=${brmId}`;
    
    return returnUrl;
  }
  